import app from '../../firebase';
import { ROOT_EU3 } from '../../general/api';

export const assistantApi =
  (process.env.NODE_ENV === 'development' && process.env.REACT_APP_PIPEDRIVE_ASSISTANT_API) ||
  ROOT_EU3;
export const isLocalAssistant =
  process.env.NODE_ENV === 'development' && Boolean(process.env.REACT_APP_PIPEDRIVE_ASSISTANT_API);
export async function assistantRequest(
  endpoint: 'pipedriveAssistantConnection' | 'aksAssistantAction' | 'aksAssistantTasks',
  body: object
) {
  const token = await app.auth().currentUser?.getIdToken();
  if (!token) throw new Error('Log ind for at bruge assistenten.');
  const response = await fetch(`${assistantApi}/${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
    cache: 'no-store',
  });
  const data = await response.json();
  if (!response.ok)
    throw new Error(typeof data.error === 'string' ? data.error : 'Forespørgslen mislykkedes.');
  return data;
}
